import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  constructor(private http: HttpClient) { }

  public async getGroupAll(idCompany: any, page: number = 10, filter?: { status: string, name: string }) {
    const size: number = 1000;
    let filterName = '';
    let filterStatus = '';
    let filterUrl = '';
    if (filter) {
      filterName = `${filter.name ? 'name@lk::' + filter.name + ',companyId@eq::' + idCompany : 'name@lk::%25,companyId@eq::' + idCompany}`;
      if (filter.status) {
        filterName += `,`;
      }
      filterStatus = `${filter.status ? 'enable@eq::' + (filter.status == 'enabled' ? 'true' : 'false') : ''}`;
      filterUrl = `${filterName}${filterStatus},depth::1&sort=id::desc`;
    } else {
      filterUrl = `name@lk::%25,companyId@eq::${idCompany},depth::1&sort=id::desc`;
    }
    const url = `/assistance/group/group/all?filter=${filterUrl}&page=${page}&size=${size}`;
    console.log(url);
    const response = await this.http.get(url).toPromise();
    return response;
  }

  public async getAllGroupsRoot(idCompany: any) {
    const url = `/assistance/group/group/all?filter=name@lk::%25,companyId::${idCompany},depth@ne::0&sort=name::asc&page=0&size=5000`;
    const response = await this.http.get(url).toPromise();
    return response;
  }




  public async getGroupListChild(idGroup: any) {
    const url = `/assistance/group/group/all?filter=parent::${idGroup}&sort=id::asc&page=0&size=10`;
    const response = await this.http.get(url).toPromise();
    return response;
  }

  public async getGroupById(idGroup: string) {
    const url = `/assistance/group/group?id=${idGroup}`;
    const response = await this.http.get(url).toPromise();
    return response;
  }

  public async createGroup(group: any) {
    const url = `/assistance/group/group`;
    const response = await this.http.post(url, group).toPromise();
    return response;
  }

  public async updateGroup(group: any) {
    const url = `/assistance/group/group`;
    const response = await this.http.put(url, group).toPromise();
    return response;
  }

  public async syncGroup(companyId: any, userId: any) {
    const url = `/assistance/sync/group?companyId=${companyId}&userId=${userId}`;
    const response = await this.http.get(url).toPromise();
    return response;
  }
  public async syncGroupStatus(companyId: any, userId: any, status: any) {
    const ahora = new Date();
    const time = ahora.getTime();
    const url = `/binnacle/sync?type=SG&companyId=${companyId}&userId=${userId}&startDate=${time}&description=${status}`;
    const response = await this.http.post(url, null).toPromise();
    return response;
  }


  public async getAllGroupsAccess() {

    const url = `/identitum-api/group/access/all`;
    //const url = 'http://192.168.0.86:8989/identitum-api/group/access/all';
    const response = await this.http.get(url).toPromise();
    return response;
  }



  public async getAllUsersGroup() {

    //const url = 'http://192.168.0.86:8989/identitum-api/group/users/all';
    const url = `/identitum-api/group/users/all`;
    const response = await this.http.get(url).toPromise();
    return response;
  }


}
